// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1779713196310
      var cssReload = require("/working_dir/management-portal/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  